import { renderToString } from "react-dom/server";

const html_render = (html, revData, reviewPass = false) => {
    if(!html) {
        return null;
    }

    const body = document.createElement("div");
    body.innerHTML = html;

    let reviewTarget;
    if(reviewPass) {
        reviewTarget = revData?.filter(f => f.revType?.match(/[DHCF]/));
    } else {
        reviewTarget = revData;
    }
    reviewTarget?.forEach(f => {
        const { uniqueCode, cmptType } = f;
        
        let classes = ["review"];
        if(cmptType === "C") classes.push("complete");
        body.querySelector("*[data-uniquecode='"+uniqueCode+"']")?.classList.add(...classes);
    })

    let body2 = body.innerHTML.replaceAll(/(\[:[^\]]+:\])/g,'<a onClick=\'event.stopPropagation()\' class=\'tblref\' data-tblref=\'$1\'>$1</a>')

    return body2;
}

export default html_render;